import { render, staticRenderFns } from "./GoldenCard.vue?vue&type=template&id=782185da&scoped=true&"
import script from "./GoldenCard.vue?vue&type=script&lang=ts&"
export * from "./GoldenCard.vue?vue&type=script&lang=ts&"
import style0 from "./GoldenCard.vue?vue&type=style&index=0&id=782185da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782185da",
  null
  
)

export default component.exports